import {changeToString} from '@/service/util.js'
let getTimeArr = function(state){
  let timeArr = []
  let obj = []
  for(let i = 0; i < 96; i ++){
    obj.push({time: changeToString(i * 900), state: state})
  }
  for(let j = 0; j < 7; j ++){
    timeArr.push(JSON.parse(JSON.stringify(obj)))
  }
  return timeArr
}

export default getTimeArr